/*
#FFFFFF
#FFF8ED
#FFEFD4
#FFDBA9
#FFC072
#FE9B39
#FD7E14
#EE6108
#C54909
#9C3910
#7E3110
#441606
*/

export const orange = {
  orange0: '#FFFFFF', // 255, 255, 255
  orange1: '#FFF8ED', // 255, 248, 237
  orange2: '#FFEFD4', // 255, 239, 212
  orange3: '#FFDBA9', // 255, 219, 169
  orange4: '#FFC072', // 255, 192, 114
  orange5: '#FE9B39', // 254, 155, 57
  orange6: '#FD7E14', // 253, 126, 20 *
  orange7: '#EE6108', // 238, 97, 8
  orange8: '#C54909', // 197, 73, 9
  orange9: '#9C3910', // 156, 57, 16
  orange10: '#7E3110', // 126, 49, 16
  orange11: '#441606', // 68, 22, 6
  orange12: '#441606', // 68, 22, 6
} as const;

export const orangeDark = {
  orange0: '#000',
  orange1: '#1f1206',
  orange2: '#271504',
  orange3: '#341c0a',
  orange4: '#3f220d',
  orange5: '#4b2910',
  orange6: '#5d3213',
  orange7: '#7e4318',
  orange8: '#c36522',
  orange9: '#f76808',
  orange10: '#ff802b',
  orange11: '#ffa366',
  orange12: '#ffe0c2',
} as const;

export const orangeA = {
  orangeA1: 'hsla(20, 94.9%, 38.7%, 0.016)',
  orangeA2: 'hsla(22, 100%, 51.0%, 0.044)',
  orangeA3: 'hsla(34, 100%, 50.1%, 0.165)',
  orangeA4: 'hsla(33, 100%, 50.1%, 0.267)',
  orangeA5: 'hsla(31, 100%, 50.0%, 0.357)',
  orangeA6: 'hsla(27, 100%, 50.1%, 0.432)',
  orangeA7: 'hsla(21, 100%, 50.0%, 0.510)',
  orangeA8: 'hsla(19, 99.7%, 44.5%, 0.640)',
  orangeA9: 'hsla(24, 99.9%, 48.4%, 0.969)',
  orangeA10: 'hsla(24, 100%, 46.5%, 1)',
  orangeA11: 'hsla(16, 99.8%, 24.2%, 0.773)',
  orangeA12: 'hsla(16, 99.4%, 13.1%, 0.887)',
} as const;

/**
 *
 *
 * Archives.
 *
 * orange0: '#fff',
 * orange1: '#fefcfb',
 * orange2: '#fff8f4',
 * orange3: '#ffedd5',
 * orange4: '#ffe0bb',
 * orange5: '#ffd3a4',
 * orange6: '#ffc291',
 * orange7: '#ffaa7d',
 * orange8: '#ed8a5c',
 * orange9: '#f76808',
 * orange10: '#ed5f00',
 * orange11: '#99543a',
 * orange12: '#582d1d',
 *
 */
